import {
  Table,
  Header,
  HeaderRow,
  Body,
  Row,
  HeaderCell,
  Cell
} from '@table-library/react-table-library/table'
import { useTheme } from '@table-library/react-table-library/theme'
import moment from '@/config/moment'
import { Chip } from '@material-tailwind/react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

const theme = useTheme({
  Table: `
        --data-table-library_grid-template-columns: repeat(7, 1fr);
      `
})

export const EmployeeHistoryContractTable = ({ employeeContracts }) => {
  const { t } = useTranslation()

  return (
    <Table
      layout={{ custom: true }}
      theme={theme}
      data={{ nodes: employeeContracts }}
      className='max-h-80 mt-4 overflow-y'
    >
      {(tableList) => (
        <>
          <Header>
            <HeaderRow>
              <HeaderCell>Contratista</HeaderCell>
              <HeaderCell>ID contrato</HeaderCell>
              <HeaderCell>Tipo de contrato</HeaderCell>
              <HeaderCell>Rol</HeaderCell>
              <HeaderCell>Fecha inicio</HeaderCell>
              <HeaderCell>Fecha de desvinculación</HeaderCell>
              <HeaderCell>Jornada (hrs)</HeaderCell>
            </HeaderRow>
          </Header>

          <Body>
            {tableList &&
              tableList.map(
                ({
                  id,
                  unlinkDate,
                  contract,
                  employeeRole,
                  active,
                  startDate,
                  workingHours,
                  contractType,
                  ...data
                }) => (
                  <Row key={id} item={data}>
                    <Cell>{contract?.company?.name}</Cell>
                    <Cell>{contract?.id}</Cell>
                    <Cell>{t(`${contractType}.one`)}</Cell>
                    <Cell>{employeeRole?.name}</Cell>
                    <Cell>{moment(startDate).format('L')}</Cell>
                    <Cell>
                      {!unlinkDate && active ? (
                        <Chip
                          variant='ghost'
                          color='green'
                          size='sm'
                          className='capitalize text-center max-h-6'
                          value='Contrato Actual'
                        />
                      ) : (
                        <Chip
                          variant='ghost'
                          color='red'
                          size='sm'
                          className='capitalize text-center max-h-6'
                          value={
                            unlinkDate
                              ? moment(unlinkDate).format('L')
                              : 'Sin fecha'
                          }
                        />
                      )}
                    </Cell>
                    <Cell>{workingHours || '-'}</Cell>
                  </Row>
                )
              )}
          </Body>
        </>
      )}
    </Table>
  )
}
EmployeeHistoryContractTable.propTypes = {
  employeeContracts: PropTypes.array
}
